/* global DetectUserAgent */
import { Workbox } from "workbox-window";

export function registerServiceWorker() {
  if (!DetectUserAgent.isPrerender() && "serviceWorker" in navigator) {
    const wb = new Workbox("/service-worker.js");

    wb.register();
  }
}
